import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

export const useCustomSlugQuery = (pathname: string) => {
  const [response, setResponse] = useState({ key: '', filter: {} });

  const segments = pathname.split('/').splice(1);
  const slug = segments[1];

  const fetchData = useCallback(() => {
    if (segments[0] === 'find-jobs' && slug) {
      axios.get(`/api/customSlugPages/${slug}`).then((response) => {
        setResponse({
          key: response.data?.name,
          filter: response.data?.filter,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [slug, fetchData]);

  return response;
};
